import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export default function useTabChange(initialValue = 0) {
  const [value, setValue] = useState(initialValue);

  /**
   * @function handleChange
   * @description Handle tab change
   * @param {object} event
   * @param {number} newValue
   * @returns {void}
   * @example handleChange(event, newValue)
   */
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return [value, handleChange, setValue];
}

/**
 * @function TabPanel
 * @description Tab panel
 * @param {object} props
 * @returns {JSX.Element}
 * @example <TabPanel value={value} index={0}>Tab 1</TabPanel>
 */

export function TabPanel({ children, value, index, ...other }) {
  return (
    <Box
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};
